import React, { useEffect, useRef } from 'react';
import fallbackImage from '@images/error-boundary-fallback.svg';
import { Button, useTranslation } from '@testsigma/atoms';
import { useLocation, useNavigate } from 'react-router-dom';

export type FallbackProps = {
  hasError: boolean;
  resetErrorState: () => void;
};

const Fallback: React.FC<FallbackProps> = ({ hasError, resetErrorState }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const previousLocation = useRef(location.pathname);

  useEffect(() => {
    if (hasError && location.pathname !== previousLocation.current) {
      resetErrorState();
    }
  }, [location.pathname]);

  const handleGoBack = () => {
    navigate(-1);
    resetErrorState();
    //to reload the page after the page is navigated to previous route
    setTimeout(() => window.location.reload(), 100);
  };
  const { t } = useTranslation();
  return (
    <div className='flex flex-col justify-center items-center h-full'>
      <img src={fallbackImage} alt='something went wrong' className='mb-7' />
      <h1 className='text-[18px] text-unique-600 font-semibold mb-1'>
        {t('common.error_boundary_heading_text')}
      </h1>
      <h2 className='text-2xs text-secondary-500 mb-5 font-light'>
        {t('common.error_boundary_subtext')}
      </h2>
      <Button onClick={handleGoBack}>{t('common.go-back.label')}</Button>
      <div
        className='absolute bottom-8 flex justify-center text-2xs text-secondary-500'
        dangerouslySetInnerHTML={{
          __html: t('common.error_boundary_footer_text'),
        }}
      />
    </div>
  );
};

export default Fallback;
